import React from "react";
import { useAuth } from "../../supabase/AuthProvider";
import { useNavigate } from "react-router-dom";
import { Dropdown } from "../common";
import { Award, LogIn, LogOut } from "lucide-react";
import { userData } from "../../types/newtypes";
import { Features, useEntitlements } from "../../hooks/useEntitlements";

interface MainMenuProps {
  isMobile?: boolean;
  currentUser?: userData | null;
}

const MainMenu: React.FC<MainMenuProps> = ({
  isMobile = false,
  currentUser,
}) => {
  const { user, loading, signOut } = useAuth();
  const { hasFeature } = useEntitlements();

  const navigate = useNavigate();

  const APP_LOGIN_URL = process.env.REACT_APP_APP_HOME_URL
    ? `${process.env.REACT_APP_APP_HOME_URL}/login`
    : "https://app.pedagogue.io/login";

  const handleSignOut = async (): Promise<void> => {
    try {
      await signOut();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Error signing out:", error);
    }
  };

  if (loading) {
    return <></>;
  }

  const displayName = currentUser?.name || "";

  const items = user
    ? [
      ...(hasFeature(Features.COURSE_CERTIFICATES)
        ? [
          {
            id: "certificates",
            label: "Certificates",
            icon: <Award size={18} />,
            onClick: () => navigate("/certificates"),
          },
        ]
        : []),
      // {
      //   id: "settings",
      //   label: "Settings",
      //   icon: <Settings size={16} strokeWidth={1.5} />,
      //   onClick: () => console.log("Settings clicked"),
      // },
      {
        id: "logout",
        label: "Logout",
        icon: <LogOut size={18} />,
        onClick: handleSignOut,
      },
    ]
    : [
      {
        id: "login",
        label: "Login",
        icon: <LogIn size={16} strokeWidth={1.5} />,
        onClick: () => { window.location.href = APP_LOGIN_URL; },
      },
    ];

  return (
    <div className={isMobile ? "w-full" : ""}>
      <Dropdown
        name={displayName}
        items={items}
        avatarSrc={currentUser?.avatar_url || undefined}
      />
    </div>
  );
};

export default MainMenu;
